export default __webpack_public_path__ + "static/caption-03-jp-a94f23a37f0d63f5a0e77f5474b8d482.png";